import React from 'react';
import images from '../../constants';
import Technologies from '../Technologies/Technologies';
import styles from './Introduction.module.scss';

function Introduction({ isLight }) {
  return (
    <section className={styles.section}>
      <h1 className={styles.h1}>Hey, I'm William.</h1>
      <p className={styles.p}>
        I'm a <span>Front End Developer</span> with a focus on React.
      </p>
      <p className={styles.p}>If you'd like, check below to find my Github and Linkedin.</p>
      <div className={styles.icons}>
        <a id="github-light" href="https://github.com/Passenger89" target="_blank" rel="noreferrer">
          <img className={styles.icon} src={isLight ? images.githubLight : images.githubDark} alt="github" />
        </a>
        <a
          href="https://www.linkedin.com/in/williamnicholson10101/"
          id="linkedin-light"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.icon} src={isLight ? images.linkedinLight : images.linkedinDark} alt="linkedin" />
        </a>
      </div>
      <Technologies />
    </section>
  );
}

export default Introduction;
